<script>
  import { fade } from "svelte/transition";
</script>

<div class="page-container" in:fade={{ delay: 50, duration: 250 }}>
  <slot />
</div>
